const initialValue = {
    message: ""
};

export default function errorReducer(state = initialValue, action) {
    switch (action.type) {
        case "ERROR_OBTAIN":
            return {...state, message: action.payload};
        case "ERROR_REMOVE":
            return {...state, message: ""};
        case "CHANGE_FARM":
        case "USER_LOGOUT_FULFILLED": {
            return initialValue;
        }
        default:
            return state
    }
}
